import Vue from 'vue'
import domUtils from 'util/dom-utils'
import { Filter as IFilter } from 'services/api-service'
import { FilterStore } from 'store/filter-store'
import modalTabControlMixin from 'mixins/modal-tab-control-mixin'
import FilterOptionsGroup from './filter-options-group'

import withRender from './filter-list.html'
import './filter.scss'


export default withRender(Vue.extend({
  name: 'FilterList',
  data() {
    return {
      tempFilterStore: (new FilterStore())
    }
  },
  mixins: [modalTabControlMixin],
  props: {
    filters: { type: Array },
    filterStore: { type: Object }
  },
  components: { 'tt-filter-options-group': FilterOptionsGroup },
  computed: {
    filterGroups() {
      return this.filters.map((filter: IFilter) => {
        const tempFilters = this.tempFilterStore.filters
        let activeOptions = []
        if (tempFilters[filter.group]) {
          activeOptions = tempFilters[filter.group][filter.name] || []
        }
        return { filter, activeOptions }
      })
    },
    isMenuExpanded() {
      return this.$parent.isMenuExpanded
    }
  },
  methods: {
    applyFilters() {
      // now we can set the filters on the filterStore that is used to execute the backend
      // call for the data based on these filters.  Need to do a deep copy
      const tempFilterJsonString = JSON.stringify(this.tempFilterStore.filters)
      this.filterStore.filters = JSON.parse(tempFilterJsonString)
      this.close()
    },
    clearAllFilters() {
      this.tempFilterStore.clearFilters()
    },
    close() {
      this.$parent.close()
    },
    optionSelected(group, filterName, option) {
      this.tempFilterStore.toggleFilterOption(group, filterName, option)
    },
    outsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.close()
      }
    }
  },
  watch: {
    isMenuExpanded() {
      if (this.isMenuExpanded) {
        // set the filters of the tempFilterStore to be the same as the current filters as a
        // starting point. Keeping a temporaray store because the user can make changes to the
        // filters but they are not applied until the user clicks "Apply".
        // Need to make a deep copy
        const existingFilterJsonString = JSON.stringify(this.filterStore.filters)
        this.tempFilterStore.filters = JSON.parse(existingFilterJsonString)
        // due to a timing issue, if not rendered yet, need to wait by using safeFocus
        domUtils.safeFocus(this.$el).then(() => {
          // just in case it was already added, remove it first
          document.body.removeEventListener('click', this.outsideClick, false)
          document.body.addEventListener('click', this.outsideClick, false)
          // manually focus on the menu
          domUtils.safeFocus(this.$el)
        })
      } else {
        document.body.removeEventListener('click', this.outsideClick, false)
      }
    }
  },
  beforeDestroy() {
    // just to be sure we don't leave the event around
    document.body.removeEventListener('click', this.outsideClick, false)
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/menu/filter-list.ts